export default __webpack_public_path__ + "static/media/for-business-blood-kit-image.641327c8.png";